import { createSlice } from '@reduxjs/toolkit';
import { StatusMessages } from 'react-media-recorder';

import { IExcerpt } from '@/entities/video-reading';

interface IState {
  timer: number;
  status: StatusMessages;
  selectedExcerpt: IExcerpt | null;
}

const initialState: IState = {
  timer: 0,
  status: 'idle',
  selectedExcerpt: null
};

const videoReadingSlice = createSlice({
  name: 'videoReading',
  initialState,
  reducers: {
    /**
     * Обновление таймера
     * @param state Состояне
     * @param root0 Пропсы
     * @param root0.payload Новое значение таймера
     */
    updateTimer: (state, { payload }: { payload: number }) => ({
      ...state,
      timer: payload
    }),

    /**
     * Обновление статуса видеочитки
     * @param state Состояне
     * @param root0 Пропсы
     * @param root0.payload Новое значение статуса
     */
    updateStatus: (state, { payload }: { payload: StatusMessages }) => ({
      ...state,
      status: payload
    }),

    /**
     * Обновление выбранного отрывка
     * @param state Состояне
     * @param root0 Пропсы
     * @param root0.payload Новый отрывок
     */
    updateSelectedExcerpt: (state, { payload }: { payload: IExcerpt }) => ({
      ...state,
      selectedExcerpt: payload
    }),
    /** Ресет видочитки */
    reset: () => initialState
  }
});

export const {
  reset: resetVideoReading,
  updateTimer,
  updateStatus,
  updateSelectedExcerpt
} = videoReadingSlice.actions;
export const { reducer: videoReadingReducer } = videoReadingSlice;
